import { useState } from "react";
import { toast } from "sonner";
import { Barcode } from "lucide-react";
import { download } from "@/lib/api";
import { Field } from "@/components/Common";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export const LabelsDialog = ({ items }) => {
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState([]);
  const [copie, setCopie] = useState(1);
  const usable = items.filter((p) => p.barcode || p.codice);
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]);
  const print = () => download("/stampe/etichette.pdf", { ids: sel.join(","), copie }).then(() => setOpen(false)).catch((e) => toast.error(e.message));
  return (
    <>
      <Button variant="outline" className="bg-white" data-testid="labels-button" onClick={() => { setSel(usable.map((p) => p.id)); setOpen(true); }}><Barcode className="mr-2 h-4 w-4" />Etichette</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="labels-dialog">
          <DialogHeader><DialogTitle>Stampa etichette con codice a barre</DialogTitle></DialogHeader>
          {usable.length === 0 ? <p className="text-sm text-slate-600">Nessun articolo con codice a barre o codice.</p> : (
            <div className="max-h-72 space-y-2 overflow-y-auto">
              {usable.map((p) => (
                <label key={p.id} className="flex items-center gap-3 text-sm" data-testid={`label-item-${p.id}`}>
                  <Checkbox checked={sel.includes(p.id)} onCheckedChange={() => toggle(p.id)} />
                  <span className="font-mono text-xs text-slate-600">{p.barcode || p.codice}</span><span className="truncate">{p.descrizione}</span>
                </label>
              ))}
            </div>
          )}
          <Field label="Copie per articolo (24 etichette per foglio A4)"><Input data-testid="labels-copies-input" type="number" min="1" max="100" value={copie} onChange={(e) => setCopie(e.target.value)} /></Field>
          <DialogFooter><Button data-testid="labels-print-button" disabled={!sel.length} onClick={print}>Stampa PDF</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
